import mapCartData from './mapCartData'

export default function(context, endpoint, body, errorMsg) {
    
    let url = endpoint
    const contentType = "application/json"
    
    const fetchConfig = {
        method: process.env.METHOD_POST,
        body: JSON.stringify(body),
        headers: { "Content-Type": contentType }
    }

    if (fetchConfig.method === 'GET') {
        delete fetchConfig.body
    }

    context.commit('start_cart_spinner')

    return fetch(url, fetchConfig)
        .then(res => {
            if(res.ok) return res.json()
            throw new Error(errorMsg)
        })
        .then(json => {
            context.commit('set_cart_data', mapCartData(json))
            context.commit('stop_cart_spinner')
            return true
        })
        .catch(err => {
            console.error(err)
            context.commit('stop_cart_spinner')
            return false
        })
}